/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  GET_ITEMS: state => state.events,
  GET_ITEM: state => (eventId) => state.events.find((event) => event.id == eventId),
  GET_ITEMS_BY_ARTISAN: state => state.my_events,
  GET_ITEM_BY_ARTISAN: state => (eventId) => state.my_events.find((event) => event.id == eventId),
}
